<template>
  <div class="flex flex-col min-h-screen items-center">
    <div class="flex justify-between items-center w-full max-w-[1280px]">
      <div class="ml-4 sm:ml-0">
        <LogoIcon />
      </div>
      <div class="h-12 mt-5 mb-5 mr-4 sm:mr-8">
        <LanguageSwitch />
      </div>
    </div>
    <div class="max-w-[460px] w-full text-center flex-grow px-4">
      <h2 class="mt-5 mt-10 mb-6 text-center">
        {{ $t('messages.forget_password.title') }}
      </h2>
      <p class="b1 block text-left text-zyxel-gray-800 mb-8">
        {{ $t('messages.forget_password.description') }}
      </p>
      <span class="b2 block text-left w-full mb-2 text-zyxel-gray-800">{{ $t('messages.text_input.email') }}</span>
      <input
        id="email"
        v-model="email"
        type="text"
        inputmode="email"
        :class="['text-input pt-4 pl-4 pb-4 text-left h-12 w-full', { 'error-input': errors.email }]"
        placeholder="name@example.com"
        @keyup.enter="handleForgetPassword"
      >
      <span
        v-if="errors.email"
        class="error-message mt-1 b2 block text-left w-full"
      >{{
        $t(errors_msg.email) }}</span>
      <button
        class="button-primary w-full mt-4 mb-3"
        @click="handleForgetPassword"
      >
        {{ $t('messages.button.send')
        }}
      </button>
      <div class="mt-4 mb-6">
        <span
          class="mr-4 b1 text-zyxel-gray-800"
          style="color: #575757"
        >{{
          $t('messages.common.hint_remember_password') }}</span><router-link
          class="b1 text-zyxel-green-700"
          :to="{ name: 'SignIn' }"
        >
          {{ $t('messages.common.link_sign_in') }}
        </router-link>
      </div>

      <div class="mb-6">
        <span
          class="mr-4 b1"
          style="color: #575757"
        >{{ $t('messages.common.hint_new_user') }}</span>
        <router-link
          class="b1 text-zyxel-green-700"
          :to="{ name: 'SignUp' }"
        >
          {{
            $t('messages.common.link_create_account') }}
        </router-link>
      </div>
    </div>
    <ZyxelFooter />
  </div>
</template>
<script>
import LogoIcon from '@/components/LogoIcon.vue';
import LanguageSwitch from "@/components/LanguageSwitch.vue";
import ZyxelFooter from "@/components/ZyxelFooter.vue";
import axios from 'axios';
import { apiBaseUrl } from '@/config';
import { logger } from '@/utils/logger';


export default {
    name: 'ForgetPasswordPage',
    components: {
        LogoIcon,
        LanguageSwitch,
        ZyxelFooter,
    },
    data() {
        return {
            email: '',
            errors: {
                email: false,
            },
            errors_msg: {
                email: false,
            }
        };
    },
    methods: {
        handleForgetPassword() {
            if (!this.checkInputs()) {
                return;
            }
            const appid = localStorage.getItem('appId');
            const urlWithQuery = `${apiBaseUrl}/api/users/forget_password?_fdl_app_id=${encodeURIComponent(appid)}`;

            axios.post(urlWithQuery, { email: this.email })
                .then(response => {
                    logger.log(response);
                    this.$router.push({ name: 'WaitForgetPassword', query: { to_email: this.email } });
                })
                .catch(error => {
                    logger.log(error);
                    this.errors.email = true;
                });
        },
        validateEmail(email) {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            return re.test(email);
        },
        checkInputs() {
            let valid = true;
            this.errors.email = false;

            if (this.email.trim().length === 0) {
                this.errors.email = true;
                this.errors_msg.email = "messages.error_msg.field_empty";
                valid = false;
            } else if (this.email.trim().length > 250) {
                this.errors.email = true;
                this.errors_msg.email = "messages.error_msg.length_250";
                valid = false;
            } else if (!this.validateEmail(this.email.trim())) {
                this.errors.email = true;
                this.errors_msg.email = "messages.error_msg.email_valid";
                valid = false;
            }
            return valid;
        }
    },
}
</script>